import React from "react";

export const ClientLogoCard = ({ Icon }) => {
  return (
    <li>
      <img src={Icon} alt="logo" />
    </li>
  );
};
